import gql from 'graphql-tag'

export const IMPORTAR_USUARIOS_QUERY = gql`
  query importarUsuariosQuery {
    importStatus {
      total
      done
      progress
      fileName
      status
    }
  }
`
